<script setup lang="ts">
import { type FontAwesomeIconProps } from '@fortawesome/vue-fontawesome';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { type BasicColor, getBgClass } from '@tailwind-preset/colors';

export interface VIconSquareProps {
  icon: FontAwesomeIconProps['icon'];
  color?: BasicColor;
}

const props = withDefaults(defineProps<VIconSquareProps>(), {
  color: 'teal',
});
</script>

<template>
  <div
    :class="[
      'size-8 content-center rounded',
      'text-center text-sm text-white/90',
      getBgClass(props.color),
    ]"
  >
    <FontAwesomeIcon :icon="props.icon" />
  </div>
</template>
